<template>
  <div class="table-pager">
    <span class="table-pager__range">{{ range }}</span>

    <div class="table-pager__controls">
      <label class="table-pager__size">
        <span>Itens por página</span>
        <select class="form-control" :value="pageSize"
                @change="$emit('update:pageSize', Number($event.target.value))">
          <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
        </select>
      </label>

      <nav class="table-pager__pages" aria-label="Paginação" v-if="count > 1">
        <button type="button" class="table-pager__btn" aria-label="Página anterior"
                :disabled="current === 1" @click="go(current - 1)">‹</button>
        <template v-for="(item, index) in items">
          <span class="table-pager__gap" v-if="item === '…'" :key="'gap' + index">…</span>
          <button type="button" v-else :key="item" class="table-pager__btn"
                  :class="{ 'is-active': item === current }"
                  :aria-current="item === current ? 'page' : null"
                  @click="go(item)">{{ item }}</button>
        </template>
        <button type="button" class="table-pager__btn" aria-label="Próxima página"
                :disabled="current === count" @click="go(current + 1)">›</button>
      </nav>
    </div>
  </div>
</template>

<script>
import { PAGE_SIZES, clampPage, pageCount, pageItems, rangeLabel } from './pagination';

/**
 * Rodape de paginacao: "1–10 de N" a esquerda; tamanho da pagina e botoes
 * numerados a direita. Nao guarda estado: `page` e `pageSize` sao do pai
 * (.sync), que decide quando voltar para a primeira pagina.
 */
export default {
  name: 'table-pager',
  props: {
    total: { type: Number, required: true },
    page: { type: Number, required: true },
    pageSize: { type: Number, required: true },
    pageSizes: { type: Array, default: () => PAGE_SIZES },
  },
  computed: {
    count() {
      return pageCount(this.total, this.pageSize);
    },
    current() {
      return clampPage(this.page, this.total, this.pageSize);
    },
    items() {
      return pageItems(this.current, this.count);
    },
    range() {
      return rangeLabel(this.current, this.pageSize, this.total);
    },
  },
  methods: {
    go(page) {
      const next = clampPage(page, this.total, this.pageSize);
      if (next !== this.current) this.$emit('update:page', next);
    },
  },
};
</script>

<style scoped>
.table-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 14px;
  font-size: 12px;
  color: #4e5560;
}
.table-pager__controls { display: flex; align-items: center; flex-wrap: wrap; gap: 16px; }
.table-pager__size { display: flex; align-items: center; gap: 8px; margin: 0; font-weight: 400; }
.table-pager__size .form-control { width: 76px; height: 30px; padding: 2px 8px; font-size: 12px; }
.table-pager__pages { display: flex; align-items: center; gap: 4px; }
.table-pager__gap { padding: 0 4px; color: #9ca0a7; }

/* Resets do `.filters button` global (custom.css), que estica todo botao
   dentro de .filters num botao azul de 120x33. */
.table-pager__btn {
  position: static;
  top: 0;
  width: auto;
  min-width: 30px;
  height: 30px;
  margin: 0;
  padding: 0 8px;
  line-height: 1;
  border: 1px solid #d5d7da;
  /* !important: `.filters button` forca 4px com !important. */
  border-radius: 6px !important;
  background: #fff;
  color: #3a424e;
  font-size: 12px;
}
.table-pager__btn:hover:not(:disabled):not(.is-active) { background: #f7f9fc; color: #3a424e; }
.table-pager__btn.is-active,
.table-pager__btn.is-active:hover { background: #1b59f8; border-color: #1b59f8; color: #fff; }
/* Cor explicita: sem ela o `.filters button:hover` global pinta o botao
   desabilitado de azul-escuro. */
.table-pager__btn:disabled,
.table-pager__btn:disabled:hover { background: #fff; color: #3a424e; opacity: .4; cursor: default; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/tablePager.vue